import React, { useState, useCallback, Suspense } from "react";
import Accordion from "react-bootstrap/esm/Accordion";
import Row from "react-bootstrap/esm/Row";
import { Container } from "reactstrap";

// ✅ Lazy load only required components
const CompactFormEdit = React.lazy(() => import("./PaperTradingFormEdit"));
const CounterPartyTable = React.lazy(() => import("./CounterPartyTable"));

function CounterpartyTrades() {
  const [contractCreated, setContractCreated] = useState(0);
  const [copiedData, setCopiedData] = useState<any>(null);
  const [isEditMode, setEditMode] = useState<boolean>(false);
  const [editedData, setEditedData] = useState<any>(null);

  // ✅ Stable callbacks
  const handleSetCopiedData = useCallback((data: any) => setCopiedData(data), []);
  const handleSetEditMode = useCallback((mode: boolean) => setEditMode(mode), []);
  const handleSetEditedData = useCallback((data: any) => setEditedData(data), []);

  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <div>
            <div className="table-ad">
              <Accordion defaultActiveKey="0" className="table-ad__addInputs">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="accordion_button">
                    Counterparty Table
                  </Accordion.Header>
                  <Accordion.Body>
                    {isEditMode && (
                      <Suspense fallback={<div>Loading edit form...</div>}>
                        <CompactFormEdit
                          contractCreated={contractCreated}
                          setContractCreated={setContractCreated}
                          copiedData={copiedData}
                          setEditMode={handleSetEditMode}
                          isEditMode={isEditMode}
                          editedData={editedData}
                        />
                      </Suspense>
                    )}
                    <Suspense fallback={<div>Loading table…</div>}>
                      <CounterPartyTable
                        contractCreated={contractCreated}
                        setCopiedData={handleSetCopiedData}
                        setEditMode={handleSetEditMode}
                        setEditedData={handleSetEditedData}
                      />
                    </Suspense>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default React.memo(CounterpartyTrades);
